import type { CustomFieldAppliesTo, CustomFieldNarrowingWarning } from '@/lib/contacts/types'

export function customFieldAppliesToLabel(appliesTo: CustomFieldAppliesTo) {
  if (appliesTo === 'both') return 'People & Orgs'

  return appliesTo
}

export function appliesToOnlyLabel(appliesTo: CustomFieldAppliesTo) {
  if (appliesTo === 'People') return 'People only'
  if (appliesTo === 'Organizations') return 'Organizations only'

  return customFieldAppliesToLabel(appliesTo)
}

export function countedContactType(warning: CustomFieldNarrowingWarning) {
  const contactType = warning.excluded_contact_type
  if (warning.deleted_value_count === 1) return contactType
  if (contactType === 'Person') return 'People'

  return `${contactType}s`
}
